<template>
  <span>
    <v-menu bottom v-model="menuOpened" :offset-y="true" transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <span>
          <v-btn :color="color" v-on="on" :disabled="disabled">
            <v-icon left>mdi-link</v-icon>{{$t(i18nKey)}}
          </v-btn>
          <help-icon v-if="false" class="ml-1" :text="'Warnung: ...'"/>
        </span>
      </template>
      <v-list>
        <v-list-item @click="doCopy">
          <v-list-item-title>
            <v-icon left>mdi-content-copy</v-icon>{{$t('common.copy-to-clipboard')}}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :href="'whatsapp://send?text=' + encodeURIComponent(shareText)">
          <v-icon left>mdi-whatsapp</v-icon>
          <v-list-item-title>{{$t('common.share-via-whatsapp')}}</v-list-item-title>
        </v-list-item>
        <v-list-item :href="'mailto:?body=' + encodeURIComponent(shareText) + '&amp;subject=' + encodeURIComponent(shareSubject)">
          <v-icon left>mdi-email</v-icon>
          <v-list-item-title>{{$t('common.share-via-email')}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import HelpIcon from "@/widgets/HelpIcon";

export default {
  name: "ShareLinkWidget",
  components: {
    HelpIcon,
  },
  props: {
    i18nKey: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary'
    },
    subject: {
      type: String,
      default: 'eSpocial Link'
    }
  },
  computed: {
    shareText: function() {
      var text = this.link;
      return text;
    },
    shareSubject: function() {
      return this.subject;
    },
  },
  data: function() {
    return {
      menuOpened: false,
      showInvitationTooltip: false
    };
  },
  watch: {},
  mounted() {},
  methods: {
    doCopy: function() {
      this.$copyText(this.link).then(
        this.onLinkCopied,
        this.onLinkCopyError
      );
    },
    onLinkCopied() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        message: this.$t('common.copy-to-clipboard-success'),
        type: "success"
      });
    },
    onLinkCopyError() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        message: this.$t('common.copy-to-clipboard-failed'),
        type: "error"
      });
    }
  }
};
</script>